<template src="./DetailAnnouncementExternal.html"></template>

<script>
import announcementService from "../../services/Announcement";
import ArrobaMedellinFooter from "@/components/ArrobaMedellinFooter/ArrobaMedellinFooter";
import ArrobaMedellinAppBarExternal from "@/components/ArrobaMedellinAppBarExternal/ArrobaMedellinAppBarExternal";

export default {
  name: "DetailAnnouncementExternal",
  components: {
    ArrobaMedellinFooter,
    ArrobaMedellinAppBarExternal,
  },
  data() {
    return {
      announcement: {
        announcement: {
          name: "",
          institution: { name: "" },
          description: "",
          category: { name: "" },
          dateInit: "",
          dateFinish: "",
        },
      },
      showViewMore: false,
    };
  },
  created() {
    this.getSpecificAnnouncement();
  },
  methods: {
    async getSpecificAnnouncement() {
      try {
        this.announcement =
          await announcementService.getSpecificAnnouncementExternal(
            this.$route.params.id
          );
      } catch (e) {
        console.error("error", e);
      }
    },
  },
};
</script>

<style lang="scss" scoped src="./DetailAnnouncementExternal.scss"></style>